/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getActiveElement,
  getUser,
  getUploaderState,
  getTextEditors,
  getActiveTextEditor,
  getElementById,
  getZoom,
  getZoomableInstance,
  getContextMenu
} from '@/store/getters'
import {
  updateActualElement,
  setActiveElement,
  setActiveTextEditor,
  toggleContextMenu,
  toggleSidebar
} from '@/store/actions'
import { elementTypes } from './configs/ElementTypes'
import ResizableRect from '../Resizeable'
import ContextMenu from '@/components/commons/ContextMenu'
import { downloadFullFont, setCustomFonts } from '../FontManager/fontDownload'

class BasicElement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 100,
      height: 100,
      top: 100,
      left: 100,
      rotateAngle: 0
    }
    this.canSetActivate = true
    this.initialUpdated = false
    this.element = React.createRef()
    this.handleResize = this.handleResize.bind(this)
    this.handleRotate = this.handleRotate.bind(this)
    this.handleDragStart = this.handleDragStart.bind(this)
    this.handleDrag = this.handleDrag.bind(this)
    this.onDragEnd = this.onDragEnd.bind(this)
    this.onDragStartKey = this.onDragStartKey.bind(this)
    this.onDragEndKey = this.onDragEndKey.bind(this)
    this.handleRotateEnd = this.handleRotateEnd.bind(this)
    this.onImageLoaded = this.onImageLoaded.bind(this)
    this.activateTextElement = this.activateTextElement.bind(this)
    this.save = this.save.bind(this)
    this.openContextMenu = this.openContextMenu.bind(this)
  }

  /**
   * GET INITIAL VALUES OF THE LEMENT
   */
  componentDidMount() {
    const { attributes, styles } = this.props
    if (attributes) {
      const rotate = attributes.transform
        ? +attributes.transform.replace(/rotate\(|deg\)/g, '')
        : 0
      const left = attributes.left ? +attributes.left.replace(/px/, '') : 0
      const top = attributes.top ? +attributes.top.replace(/px/, '') : 0
      this.setState({
        left: left,
        top: top,
        rotateAngle: rotate
      })
    }

    if (styles) {
      const width = +styles.width.replace(/px/, '')
      const height = +styles.height.replace(/px/, '')
      this.setState({
        width,
        height
      })
      const fontFamily = styles['fontFamily']
      const fontPath = styles['fontPath']
      if (fontPath) {
        setCustomFonts(fontFamily, fontPath)
      }
      if (fontFamily && !fontPath) {
        downloadFullFont(fontFamily, `${fontFamily.replace(' ', '')}`, [
          'normal'
        ])
      }
    }

    // document.addEventListener( 'mousedown', this.toggleOutside )
  }

  /**
   * remove listeners on unmount component
   */
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.toggleOutside)
  }

  /**
   * WHEN CLICK OUTSIDE ITEM
  */
  toggleOutside = e => {
    const {
      setActiveElement,
      id,
      setActiveTextEditor,
      zoomableInstance,
      toggleSidebar
    } = this.props
    const sideBar = document.querySelector('#sideBar')
    const mainHeader = document.querySelector('#mainHeader')
    const rootEl = document.querySelector(`#element-${id}`)

    if (sideBar && sideBar.contains(e.target)) {
      return
    }

    if (mainHeader && mainHeader.contains(e.target)) {
      return
    }

    if (rootEl && rootEl.contains(e.target)) {
      return
    }

    if (
      typeof e.target.className === 'string' &&
      e.target.className.indexOf('elementActive') !== -1
    ) {
      return
    }

    setTimeout(() => {
      setActiveElement(null)
      setActiveTextEditor(null)
      if (zoomableInstance) {
        zoomableInstance.resume()
      }
    }, 0)

    document.removeEventListener('mousedown', this.toggleOutside)

    toggleSidebar({
      isOpened: true,
      name: 'layers'
    })
  }

  /**
   * CONST WHEN SET ELEMENT ACTIVE
   */
  activateElement = e => {
    const {
      setActiveElement,
      item,
      actualElement,
      toggleContextMenu } = this.props

    e.stopPropagation()
    e.preventDefault()

    if (!this.canSetActivate) {
      return
    }

    if (!actualElement) {
      setActiveElement({
        id: item.id,
        type: item.content.elementType
      })
    }

    document.addEventListener('mousedown', this.toggleOutside)

    toggleContextMenu({
      show: true,
      data: item
    })
  }

  editElement = e => {
    const {
      setActiveTextEditor,
      textEditors,
      activeTextEditor,
      toggleSidebar, item } = this.props

    if (item.content.elementType === 'text' && !activeTextEditor) {
      setActiveTextEditor({
        id: item.id,
        textEditors
      })

    }

    toggleSidebar({
      isOpened: true,
      name: item.content.elementType
    })

  }

  /**
   * ACTIVE TEXT ELEMENT
   */
  activateTextElement() {
    const {
      setActiveTextEditor,
      textEditors,
      activeTextEditor,
      item,
      zoomableInstance,
      toggleSidebar
    } = this.props
    if (zoomableInstance) {
      zoomableInstance.pause()
    }
    if (item.content.elementType === 'text' && !activeTextEditor) {
      setActiveTextEditor({
        id: item.id,
        textEditors
      })
      toggleSidebar({
        isOpened: true,
        name: item.content.elementType
      })
    }
  }

  /**
   * WHEN ELEMENT IS RESIZED UPDATE STATE AND
   * THE ELEMENT
   */
  handleResize = (style, isShiftKey, type) => {
    this.canSetActivate = false
    const { top, left, width, height } = style

    this.setState({
      top: top,
      left: left,
      width: width,
      height: height
    })

    const { item } = this.props
    item.content.styles = {
      ...item.content.styles,
      width: `${width}px`,
      height: `${height}px`
    }
    item.content.attributes = {
      ...item.content.attributes,
      top: `${top}px`,
      left: `${left}px`
    }
  }

  /**
   * WHEN ELEMENE RESIZE IS DONE
   * PERFORME A SAVE
   */
  handleResizeEnd = () => {
    const { item } = this.props
    const { top, left, width, height } = this.state
    let tringleStyle = null

    item.content.attributes = {
      ...item.content.attributes,
      top: `${top}px`,
      left: `${left}px`
    }

    if (item.content.elementType === elementTypes.TRIANGLE) {
      tringleStyle = {
        borderBottomWidth: `${width}px`,
        borderRightWidth: `${width / 2}px`,
        borderLeftWidth: `${width / 2}px`
      }
    }

    item.content.styles = {
      ...item.content.styles,
      width: `${width}px`,
      height: `${height}px`,
      ...tringleStyle
    }
    this.save(item)
  }

  /**
   * WHEN ROTATE ELEMENT
   */
  handleRotate = rotateAngle => {
    this.canSetActivate = false
    this.setState({
      rotateAngle: rotateAngle
    })
  }

  /**
   * WHEN ROTATE ELEMENT IS DONW
   */
  handleRotateEnd() {
    const { rotateAngle } = this.state
    const { item } = this.props
    item.content.attributes = {
      ...item.content.attributes,
      transform: `rotate(${rotateAngle}deg)`
    }
    this.save(item)
  }

  handleDragStart() {
    const { zoomableInstance } = this.props
    if (zoomableInstance) {
      zoomableInstance.pause()
    }
  }

  /**
   * HANDLE DRAG ELEMENT
   */
  handleDrag = (deltaX, deltaY) => {
    const { zoom } = this.props
    const securityZoom = zoom.scale || 1
    this.canSetActivate = false
    const left = this.state.left + deltaX / securityZoom
    const top = this.state.top + deltaY / securityZoom

    this.setState({
      left: left,
      top: top
    })
  }

  /**
   * WHEN DRAG THE ELEMENT
   */
  onDragEnd() {
    const { item, zoomableInstance } = this.props
    const left = this.state.left
    const top = this.state.top
    const { content } = item
    content.attributes = {
      ...content.attributes,
      top: `${top}px`,
      left: `${left}px`
    }
    item.content = content
    this.save(item)

    this.canSetActivate = true

    return zoomableInstance && zoomableInstance.resume()
  }

  /**
   * SAVE THE ELEMENT STATE ON DATABASE
   * @param {Object} element
   * @param {Boolean} onlySave
   */
  save(element, onlySave = false) {
    if (this.canSetActivate) {
      return
    }

    const {
      id,
      page_id,
      updateActualElement,
      user: { accessToken }
    } = this.props

    updateActualElement({
      id: id,
      pageID: page_id,
      element: element,
      accessToken,
      onlySave
    })

    setTimeout(() => (this.canSetActivate = true), 500)
  }

  onImageLoaded(e) {
    e.preventDefault()
    const imageDom = e.target
    const { item } = this.props
    const imageW = imageDom.width
    const imageH = imageDom.height
    const ratio = imageW / imageH
    const receivedWidth = +item.content.styles.width.replace(/px/, '')
    const newWidth = receivedWidth !== 200 ? receivedWidth : 500

    if (receivedWidth === newWidth) return

    let w, h

    if (imageW > newWidth) {
      const height = newWidth / ratio
      w = newWidth
      h = height
    } else {
      w = imageW
      h = imageH
    }

    this.setState({
      width: w,
      height: h
    })

    item.content.styles = {
      ...item.content.styles,
      width: `${w}px`,
      height: `${h}px`
    }
    this.save(item)
  }

  /**
   * DRAG ELEMENT WITH KEY DOWN
   * @param {*} e
   */
  onDragStartKey(e) {
    e.preventDefault()

    const {
      zoomableInstance,
      item: { content }
    } = this.props
    let { left, top } = this.state

    if (zoomableInstance) zoomableInstance.pause()

    if (e.keyCode === 37) left = left - 1
    else if (e.keyCode === 38) top = top - 1
    else if (e.keyCode === 39) left = left + 1
    else if (e.keyCode === 40) top = top + 1

    content.attributes = {
      ...content.attributes,
      top: `${top}px`,
      left: `${left}px`
    }

    this.setState({
      left: left,
      top: top
    })

    return zoomableInstance && zoomableInstance.resume()
  }

  /**
   * SAVE DRAG ELEMENT WITH KEY UP
   */
  onDragEndKey() {
    const { item } = this.props
    this.canSetActivate = false
    this.save(item)
  }

  /**
   * When opens the context menu
   * @param {Event} e
   */
  openContextMenu(e) {
    e.preventDefault()
    const { toggleContextMenu, item } = this.props

    toggleContextMenu({
      show: true,
      // top: e.pageY,
      // left: e.pageX,
      data: item
    })
  }

  render() {
    const { width, height, left, top, rotateAngle } = this.state
    const {
      id,
      page_id,
      component: Child,
      item,
      actualElement,
      activeTextEditor,
    } = this.props
    let className =
      actualElement && +actualElement.id === +id
        ? 'basic-element active'
        : 'basic-element'

    let showContextMenu = className === 'basic-element active'
      ? true
      : false

    const isText = /text/gi.test(item.content.elementType)
    const enable = activeTextEditor && +activeTextEditor.id === +id
      ? false
      : true
    // if (!enable && !!activeTextEditor) {
    //   className += ' text-active'
    // }

    return (
      <div
        className={`${className} ${activeTextEditor && activeTextEditor.id === id ? 'text-active' : ''}`}
        // onContextMenu={this.openContextMenu}
        onClick={this.activateElement}
        onDoubleClick={this.editElement}
        onKeyDown={enable ? this.onDragStartKey : () => { }}
        onKeyUp={enable ? this.onDragEndKey : () => { }}
        tabIndex="0"
        ref={this.element}
        id={`element-${id}`}
        key={id}
      >
        <ResizableRect
          enable={enable}
          left={left}
          top={top}
          width={width}
          height={height}
          rotateAngle={rotateAngle}
          // aspectRatio={false}
          // minWidth={10}
          minHeight={2}
          zoomable="n, w, s, e, nw, ne, se, sw"
          // rotatable={true}
          // onRotateStart={this.handleRotateStart}
          onRotate={this.handleRotate}
          onRotateEnd={this.handleRotateEnd}
          // onResizeStart={this.handleResizeStart}
          onResize={this.handleResize}
          onResizeEnd={this.handleResizeEnd}
          onDragStart={this.handleDragStart}
          onDrag={this.handleDrag}
          onDragEnd={this.onDragEnd}
        >
          {isText && (
            <div
              className="toggle-double"
              onDoubleClick={this.activateTextElement}
            />
          )}

          {showContextMenu && (<div className="wrapper-context-menu"> <ContextMenu editElement={this.editElement} /></div>)}

          <Child
            id={id}
            page_id={page_id}
            item={item}
            onImageLoaded={this.onImageLoaded}
          />
        </ResizableRect>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const actualElement = getActiveElement(state)
  const user = getUser(state)
  const uploaderStatus = getUploaderState(state)
  const textEditors = getTextEditors(state)
  const activeTextEditor = getActiveTextEditor(state)
  const item = getElementById(state, ownProps.id)
  const zoom = getZoom(state)
  const zoomableInstance = getZoomableInstance(state)
  const activeContextMenu = getContextMenu(state)
  return {
    actualElement,
    user,
    uploaderStatus,
    textEditors,
    activeTextEditor,
    item,
    zoom,
    zoomableInstance,
    activeContextMenu
  }
}
export default connect(
  mapStateToProps,
  {
    updateActualElement,
    setActiveElement,
    setActiveTextEditor,
    toggleContextMenu,
    toggleSidebar
  }
)(BasicElement)



// WEBPACK FOOTER //
// ./src/components/commons/editor/BasicElement.js